module.exports = __webpack_public_path__ + "toBride1-we-r-w.a01530b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-r-w.jpg
// module id = awWB
// module chunks = 0